import { AutogenModelReceivablesHistory, AutogenRowReceivablesHistory } from "./autogen/AutogenModelReceivablesHistory";

export class ModelReceivablesHistory extends AutogenModelReceivablesHistory<RowReceivablesHistory> {
	constructor() {
		super(RowReceivablesHistory);
	}
}

export class RowReceivablesHistory extends AutogenRowReceivablesHistory {
}